import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MessageNotification } from './message-notification';
import { getFilteredMessages } from './helpers';
import { errorMessagesActions } from './messages-actions';

export const Messages = ({ forTypes, messages, errorMessages, classnameModifier = '' }) =>
  // TODO Remade this without using random number as key attribute
  [...getFilteredMessages(forTypes, messages, errorMessages)].map((message) => (
    <MessageNotification key={message.id} message={message} classnameModifier={classnameModifier} />
  ));

export const mapStateToProps = ({
  messages: {
    app: { messages, errorMessages },
  },
}) => ({
  messages,
  errorMessages,
});

const mapDispatchToProps = {
  dispatchClearModalErrorMessages: errorMessagesActions.clearModalErrorMessages,
};

export const ConnectedMessages = connect(mapStateToProps, mapDispatchToProps)(Messages);

Messages.propTypes = {
  forTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  errorMessages: PropTypes.arrayOf(PropTypes.shape({})),
  messages: PropTypes.arrayOf(PropTypes.shape({})),
  classnameModifier: PropTypes.string,
};
